import React, {
  ChangeEvent,
  forwardRef,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from "react";
import { saveAs } from "file-saver";
// import anime_sm from "./anime_md.psd";
import encanto from "./canva_test.psd";
import kpop_demon from "../Test/kpop_demon.psd";
// import travel from "./travel.psd";
// import disney from "./disney.psd";
// import anime from "./anime.psd";
// import shutter_sound from "./sound/camera-shutter-shorten.mp3";
import shutter_sound from "./sound/camera-shutter-and-flash-combined-short.mp3";
import bleep_sound from "./sound/correct-2.mp3";
import success_sound from "./sound/success-1.mp3";

import { template_override } from "../Test/dev_sandbox";
const TEMPLATE = template_override;

import { readPsd } from "ag-psd";
import JSZip from "jszip";
import { AuthContext } from "../../provider/AuthProvider";
import { uploadFile } from "../../utils/db";

const PSD_ATTRS = [
  "bitsPerChannel",
  "channels",
  "children",
  "colorMode",
  "height",
  "width",
  // layer
  "top",
  "left",
  "bottom",
  "right",
  "blendMode",
  "clipping",
  "hidden",
  "layerColor",
  "name",
  "opacity",
  "transparencyProtected",
  // shape,
  "id",
  "mask",
  "vectorMask",
  "disabled",
  "paths",
  "knots",
  "open",
  "operation",
  "linked",
  "points"
];

const downloadCanvas = (
  name: string,
  canvas: HTMLCanvasElement,
  format = "image/jpg"
) => {
  const link = document.createElement("a");
  link.download = `${name}.webp`;
  link.href = canvas.toDataURL(format, 0.8);
  link.click();
  link.remove();
};

const resolveThumb = async (
  bound: { w: number; h: number },
  source: HTMLCanvasElement
): Promise<Blob> => {
  const oriW = source.width;
  const oriH = source.height;

  const scaleRatio = Math.min(bound.w, bound.h) / Math.max(oriW, oriH);
  const w = oriW * scaleRatio;
  const h = oriH * scaleRatio;

  const dest = document.createElement("canvas") as HTMLCanvasElement;

  dest.width = w;
  dest.height = h;
  const ctx = dest.getContext("2d");
  ctx!.imageSmoothingQuality = "high";
  ctx!.drawImage(source, 0, 0, w, h);
  const blob = await new Promise((res) => dest.toBlob(res, "image/webp", 0.8));

  dest.remove();

  return blob as Blob;
};

const ExportPsd = () => {
  const { user } = useContext(AuthContext);


  const uploadPsd = async (event: ChangeEvent<HTMLInputElement>) => {
    console.log("image upload")
    const files = (event.target as HTMLInputElement).files;
    if (user && files && files.length > 0) {
      const imageFile = files[0];
      // Proceed to read the file as ArrayBuffer
      const arrayBuffer = await imageFile.arrayBuffer()

      const name = imageFile.name.split(".")[0];

      const psd1 = readPsd(arrayBuffer);
      const zip = new JSZip();

      // save the metadata
      const data = JSON.stringify(psd1, PSD_ATTRS);
      zip.file("data.json", data);

      const thumbCanvas = document.createElement('canvas');
      thumbCanvas.width = psd1.width
      thumbCanvas.height = psd1.height
      const thumbCanvasCtx = thumbCanvas.getContext("2d")

      // save the images as zip
      if (psd1.children) {
        for (let i = 0; i < psd1.children.length; i++) {
          const layer = psd1.children[i];
          if (layer.canvas) {
            const blob = await new Promise((res) =>
              layer.canvas?.toBlob(res, "image/webp", 0.7)
            );
            zip.file(`${encodeURIComponent(layer.name!)}.webp`, blob as Blob);
          }
          if (!layer.name?.toLowerCase().includes("snap") && layer.canvas) {
            thumbCanvasCtx?.drawImage(layer.canvas, layer.left!, layer.top!)
          }
        }

        const content = await zip.generateAsync({ type: "blob" });

        // save the thumbnail
        const thumbBlob = await resolveThumb(
          { w: 800, h: 800 },
          // psd1.canvas!
          thumbCanvas
        );

        const result = await uploadFile(user, `ps42Templates`, {
          name,
          zipData: content,
          thumbData: thumbBlob
        });
        alert(`file uploaded: ${JSON.stringify(result.metadata)}`)
      }

    }
  }

  useEffect(() => {
    if (!user || !TEMPLATE) return;

    fetch(TEMPLATE)
      .then((res) => res.arrayBuffer())
      .then(async (arrayBuffer) => {
        const name = TEMPLATE.split("/").pop().split(".")[0];

        const psd1 = readPsd(arrayBuffer);
        const zip = new JSZip();

        // save the metadata
        const data = JSON.stringify(psd1, PSD_ATTRS);
        zip.file("data.json", data);

        // save the images as zip
        if (psd1.children) {
          for (let i = 0; i < psd1.children.length; i++) {
            const layer = psd1.children[i];
            if (layer.canvas) {
              const blob = await new Promise((res) =>
                layer.canvas?.toBlob(res, "image/webp", 0.7)
              );
              zip.file(`${encodeURIComponent(layer.name!)}.webp`, blob as Blob);
            }
          }

          const content = await zip.generateAsync({ type: "blob" });

          // save the thumbnail
          const thumbBlob = await resolveThumb(
            { w: 800, h: 800 },
            psd1.canvas!
          );

          uploadFile(user, `ps42Templates`, {
            name,
            zipData: content,
            thumbData: thumbBlob
          });
        }

        // );
        // const dataURL = psd1.canvas?.toDataURL("image/webp", 0.8)
        // saveAs(blob as Blob, "test.webp");
      });
  }, [user]);

  return (
    <>
      <input type="file" onChange={uploadPsd} accept="*" />
    </>
  );
};

export default ExportPsd;
